import React from 'react'
import '../styles/Header.css'

export default function Header() {
    return (
        <>
            <div className="header">
                <div className="container">
                    <div className="text">
                        <h2>Your Guide to Professional Courses</h2>
                        <p>
                            Find more useful tutorials to improve your skills ,
                            with group of best instructors
                        </p>
                        <button>Get started</button>
                    </div>
                </div>
            </div> 
        </>
    )
}
